import type { DistribuicaoColetor } from "@/modules/financeiro-configuracoes";
import { PARTE_ROTULOS } from "../distribuicoes.constants";
import { formatPercentual } from "../distribuicoes.utils";
import { DEMAIS_ZERO, FIXO, SEPARADOR } from "./situacao-distribuicao-dialog.constants";

export function resumoDaDistribuicao(distribuicao: DistribuicaoColetor): string[] {
  return distribuicao.partes.map(({ parte, coletores }) => {
    const comValor = coletores.filter((coletor) => coletor.percentual > 0);
    const itens = comValor.map(
      (coletor) => `${coletor.codigo} ${formatPercentual(coletor.percentual)}`,
    );
    const temZerado = comValor.length < coletores.length;
    const fixo = coletores.some((coletor) => coletor.fixo);
    let sufixo = "";
    if (fixo) sufixo = ` ${FIXO}`;
    else if (temZerado) sufixo = `  ${DEMAIS_ZERO}`;
    return `${PARTE_ROTULOS[parte]}: ${itens.join(SEPARADOR)}${sufixo}`;
  });
}
